import * as React from "react";
const SvgError = (props) => /* @__PURE__ */ React.createElement("svg", { width: 17, height: 17, viewBox: "0 0 17 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { width: 16.0521, height: 16.0521, rx: 8.02605, fill: "#FF3B3B", style: {
  fill: "#FF3B3B",
  fill: "color(display-p3 1.0000 0.2314 0.2314)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { d: "M8.02734 4.90625V9.03096", stroke: "white", style: {
  stroke: "white",
  strokeOpacity: 1
}, strokeWidth: 1.33767, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("circle", { cx: 8.02869, cy: 11.1029, r: 0.735721, fill: "white", style: {
  fill: "white",
  fillOpacity: 1
} }));
export default SvgError;
